<template>
  <VRow
    :no-gutters="noGutters"
    :align="align"
    :justify="justify"
    :justify-sm="justifySm"
    :justify-md="justifyMd"
    :justify-lg="justifyLg"
    :justify-xl="justifyXl"
    :justify-xxl="justifyXxl"
  >
    <slot />
  </VRow>
</template>

<script setup lang="ts">
import { VRow } from 'vuetify/components/VGrid';

type Align = 'center' | 'end' | 'start' | 'stretch' | 'baseline';
type Justify =
  | 'center'
  | 'end'
  | 'start'
  | 'space-around'
  | 'space-between'
  | 'space-evenly'
  | 'stretch';
type AdaptiveJustify =
  | 'center'
  | 'end'
  | 'start'
  | 'space-around'
  | 'space-between'
  | 'space-evenly';

export interface Props {
  noGutters?: boolean;
  align?: Align;
  justify?: Justify;
  justifySm?: AdaptiveJustify;
  justifyMd?: AdaptiveJustify;
  justifyLg?: AdaptiveJustify;
  justifyXl?: AdaptiveJustify;
  justifyXxl?: AdaptiveJustify;
}

defineProps<Props>();
</script>
